module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/33-e4a84ea6e8e2cb59419dbd13d34df839.jpg";